import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import logo from '../../../img/qbs_learning.png';
import { getSingleCondidate } from "../../../Redux/Actions/newJoinerAction";
import { useDispatch, useSelector } from "react-redux";
import { getNewJoinerDetails, httpCreateCondidatePersonalDetails, sendFormAuthCode } from '../../HR/onboarding/api/Calls';
import moment from "moment";
import AddFamilyDetail from "./AddFamilyDetail";
import Loader from "./../../../CommanCom/Loader"

import EmailVerification from "./EmailVerification";
import { useNavigate } from "react-router-dom";


function NewJoiningFrom() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
   const { onecondidate, loading } = useSelector((state) => state.NewJoinerReducer);
   const  [salutation,Setsalutation] = useState('');
   const  [firstname,Setfirstname] = useState('');
   const  [middlename,Setmiddlename] = useState('');
   const  [lastname,Setlastname] = useState('');
   const  [fatherhusbandname,Setfatherhusbandname] = useState('');
   const  [gender,Setgender] = useState('');
   const  [email,Setemail] = useState('');
   const  [alternateemail,Setalternateemail] = useState('');
   const  [phonenumber,Setphonenumber] = useState('');
   const  [dateofbirth,Setdateofbirth] = useState('');
   const  [hobbies,Sethobbies] = useState('');
   const  [marital_status,Setmarital_status] = useState('');
   const  [weddinganniversary,Setweddinganniversary] = useState('');
   const  [dateofjoining,Setdateofjoining] = useState('');
   const  [bloodgroup,Setbloodgroup] = useState('');
   const  [Weight,SetWeight] = useState('');
   const  [Height,SetHeight] = useState('');
   const  [personrelation,Setpersonrelation] = useState('');
   const  [nationality,Setnationality] = useState('');
   const  [aadhaarcardnumber,Setaadhaarcardnumber] = useState('');
   const  [pancardnumber,Setpancardnumber] = useState('');
   const  [uanno,Setuanno] = useState('');
   const  [Passportno,SetPassportno] = useState('');
   const  [currentAddress,SetcurrentAddress] = useState('');
   const  [PermanentAddress,SetPermanentAddress] = useState('');
   const  [bankSalaryType,SetbankSalaryType] = useState('');
   const  [accountno,Setaccountno] = useState('');
   const  [ifsc_code,Setifsc_code] = useState('');
  // const initialstate = {
    
  // }
  const [CandidateData, setCandidateData] = useState();
  //const [formValues, setFormValues] = useState(initialstate);
  const [AadharcardFiles, setFormAadharcardFilesValues] = useState('');
  const [Filepancard, setFormFilepancardValues] = useState('');
  const [PassportSizePhoto, setFormPassportSizePhotoValues] = useState('');
  const [AddressProof, setFormAddressProofValues] = useState('');
  const [CancelCheck, setFormCancelCheckValues] = useState('');
  const [Vaccination, setFormVaccinationValues] = useState('');

  const [emailCheck, setEmailCheck] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState(false)
  const [color, setColor] = useState('');
  const [age, setAge] = useState('');
  // const [Emergencycontactperson,setEmergencycontactperson] = useState('');
  const [emergencycontactperson,Setemergencycontactperson] = useState('');
  const  [emergencyphonenumber,Setemergencyphonenumber] = useState('');
 // const [Numeric, setNumeric] = useState(NumericValueState);



  const values = searchParams.get('verify')
  const [isCheckTwoFectorAuth, setIsCheckTwoFectorAuthtication] = useState(0);
 let status = onecondidate?.status;
 
  useEffect(() => {
    const base64EncodedString = values;
    const decodedString = window.atob(base64EncodedString);
    setEmailCheck(decodedString)
     dispatch(getSingleCondidate(emailCheck));
    if (isCheckTwoFectorAuth === 0 && status === 0 ) {
      getEmailVerifyCode(decodedString);
    } else {
      if (isCheckTwoFectorAuth == 1) {
        getCondidateDetail()
      }
    }


  }, [isCheckTwoFectorAuth,emailCheck,status,tab]);
 const handledateofjoining = (e) =>{
  const DOB = e.target.value;
  //alert(DOB)
  Setdateofbirth(DOB)
  if(DOB){
    
    if (dateofbirth) {
      var today = new Date();
      var birthDate = new Date(`${moment(dateofbirth).format('YYYY-MM-DD')}`);  
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
      }
      setAge(age_now)

    } else {
      setAge('');
    }
  }
 }
  //const handleChange = (e) => {
   // const { name, value } = e.target;
    //({ ...formValues, [name]: value });

    // if (formValues.dateofbirth) {
    //   var today = new Date();
    //   var birthDate = new Date(`${moment(formValues.dateofbirth).format('YYYY-MM-DD')}`);  
    //   var age_now = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //     age_now--;
    //   }
    //   setAge(age_now)

    // } else {
    //   setAge('');
    // }

  //};
  // const handleNumericChange = (e) => {
  //   const { name, value } = e.target;
  //   const re = /^[0-9]*[.,]?[0-9]*$/;
  //   if (e.target.value === '' || re.test(e.target.value)) {
  //     setNumeric({ ...Numeric, [name]: value })
  //   }
  // }
  const handleAadharcardFilesChange = (e) => {
    setFormAadharcardFilesValues(e.target.files[0]);
  };
  const handleFilepancardChange = (e) => {
    setFormFilepancardValues(e.target.files[0]);
  };
  const handlePassportSizePhotoChange = (e) => {
    setFormPassportSizePhotoValues(e.target.files[0]);
  };
  const handleAddressProofChange = (e) => {
    setFormAddressProofValues(e.target.files[0]);

  };
  const handleCancelCheckChange = (e) => {
    setFormCancelCheckValues(e.target.files[0]);
  };
  const handleVaccinationChange = (e) => {
    setFormVaccinationValues(e.target.files[0]);
  };
  const getCondidateDetail = () => {

    getNewJoinerDetails(emailCheck).then((data) => {
     
      setCandidateData(data);
     // setFormValues(data)
    })
  }
  const getEmailVerifyCode = (emailID) => {
   
    sendFormAuthCode(emailID).then((data) => {
      if (data.status) {
        setIsCheckTwoFectorAuthtication(1)
      } else {
        setIsCheckTwoFectorAuthtication(0)
      }

    })
  }

  const validateValues = (e) => {
   
    //console.log(formValues);return false;
    if (salutation === '' || salutation === 0) {
      setError({ submition: false });
      setColor({ salutation: 'red' })
      e.target.querySelector('#salutation').focus()

    } else if (fatherhusbandname === 'null' || fatherhusbandname === '') {
      setError({ submition: false });
      setColor({ fatherhusbandname: 'red' })
      e.target.querySelector('#fatherhusbandname').focus()
     } else if (gender === '') {
      setError({ submition: false });
      setColor({ gender: 'red' })
      e.target.querySelector('#gender').focus()
    } else if (email === '' && CandidateData?.personal_email === '') {
      setError({ submition: false });
      setColor({ email: 'red' })
      e.target.querySelector('#email').focus()
    } else if (phonenumber === '' && CandidateData.contact_no === '') {
      setError({ submition: false });
      setColor({ phonenumber: 'red' })
      e.target.querySelector('#phonenumber').focus()
    } else if (dateofbirth === '') {
      setError({ submition: false });
      setColor({ dateofbirth: 'red' })
      e.target.querySelector('#dateofbirth').focus()
    } else if (marital_status === '') {
      setError({ submition: false });
      setColor({ marital_status: 'red' })
      e.target.querySelector('#marital_status').focus()
    } else if (bloodgroup === '') {
      setError({ submition: false });
      setColor({ bloodgroup: 'red' })
      e.target.querySelector('#bloodgroup').focus()
    } else if (emergencycontactperson === '') {
      setError({ submition: false });
      setColor({ emergencycontactperson: 'red' })
      e.target.querySelector('#emergencycontactperson').focus()
    } else if (personrelation === '') {
      setError({ submition: false });
      setColor({ personrelation: 'red' })
      e.target.querySelector('#personrelation').focus()
    } else if (emergencyphonenumber === '') {
      setError({ submition: false });
      setColor({ emergencyphonenumber: 'red' })
      e.target.querySelector('#emergencyphonenumber').focus()
    } else if (nationality === '') {
      setError({ submition: false });
      setColor({ nationality: 'red' })
      e.target.querySelector('#nationality').focus()
    } else if (aadhaarcardnumber === '') {
      setError({ submition: false });
      setColor({ aadhaarcardnumber: 'red' })
      e.target.querySelector('#aadhaarcardnumber').focus()
    } else if (AadharcardFiles === '') {
      setError({ submition: false });
      setColor({ aadharcardfile: 'red' })
      e.target.querySelector('#aadharcardfile').focus()
    } else if (pancardnumber === '') {
      setError({ submition: false });
      setColor({ pancardnumber: 'red' })
      e.target.querySelector('#pancardnumber').focus()
    } else if (Filepancard === '') {
      setError({ submition: false });
      setColor({ filepancard: 'red' })
      e.target.querySelector('#filepancard').focus()
    } else if (PassportSizePhoto === '') {
      setError({ submition: false });
      setColor({ passportSizePhoto: 'red' })
      e.target.querySelector('#passportSizePhoto').focus()
    } else if (AddressProof === '') {
      setError({ submition: false });
      setColor({ AddressProof: 'red' })
      e.target.querySelector('#AddressProof').focus()
    } else if (currentAddress === '') {
      setError({ submition: false });
      setColor({ currentAddress: 'red' })
      e.target.querySelector('#currentAddress').focus()
    } else if (PermanentAddress === '') {
      setError({ submition: false });
      setColor({ PermanentAddress: 'red' })
      e.target.querySelector('#PermanentAddress').focus()
    } else if (bankSalaryType === '') {
      setError({ submition: false });
      setColor({ bankSalaryType: 'red' })
      e.target.querySelector('#bankSalaryType').focus()
    } else if (accountno === '') {
      setError({ submition: false });
      setColor({ accountno: 'red' })
      e.target.querySelector('#accountno').focus()
    } else if (ifsc_code === '') {
      setError({ submition: false });
      setColor({ ifsc_code: 'red' })
      e.target.querySelector('#ifsc_code').focus()
    } else if (CancelCheck === '') {
      setError({ submition: false });
      setColor({ cancelCheck: 'red' })
      e.target.querySelector('#cancelCheck').focus()
    } else {
      setError({ submition: true });
      
    }
    return error;
   // return error;
  };
  const handleSavePersonalProfile = (e) => {
    e.preventDefault();
    validateValues(e);
    //setError({submition:true});
    if (error.submition == true) {

      //const NewData = Object.values(formValues.AddressProof)
      const formdata = new FormData();
      formdata.append('salutation', salutation?salutation:'');
      formdata.append('firstname', CandidateData.first_name ? CandidateData.first_name : firstname);
      formdata.append('middlename', middlename?middlename:'');
       formdata.append('lastname', lastname?lastname:'');
       formdata.append('fatherhusbandname', fatherhusbandname?fatherhusbandname:'');
       formdata.append('gender', gender);
       formdata.append('email', CandidateData.personal_email ? CandidateData.personal_email : email);
       formdata.append('alternateemail', alternateemail);
       formdata.append('phonenumber', CandidateData.contact_no ? CandidateData.contact_no : phonenumber);
       formdata.append('dateofbirth', dateofbirth);
       formdata.append('age', age);
      formdata.append('hobbies', hobbies);
      formdata.append('marital_status', marital_status);
      formdata.append('weddinganniversary', weddinganniversary);
      formdata.append('dateofjoining', CandidateData.dateofjoining ? CandidateData.dateofjoining : dateofjoining)

      formdata.append('bloodgroup', bloodgroup);
      formdata.append('Weight', Weight);
      formdata.append('Height', Height);

      formdata.append('emergencycontactperson', emergencycontactperson);
      formdata.append('personrelation', personrelation);
      formdata.append('emergencyphonenumber', emergencyphonenumber);
      formdata.append('nationality', nationality);
      formdata.append('aadhaarcardnumber', aadhaarcardnumber);
      formdata.append('pancardnumber', pancardnumber);
      formdata.append('uanno', uanno);
      formdata.append('Passportno', Passportno);
      formdata.append('currentAddress', currentAddress);
      formdata.append('PermanentAddress', PermanentAddress);
      formdata.append('bankSalaryType', bankSalaryType);
      formdata.append('accountno', accountno);
      formdata.append('ifsc_code', ifsc_code);

      formdata.append('AddressProof', AddressProof);
      formdata.append('PassportSizePhoto', PassportSizePhoto);
      formdata.append('Filepancard', Filepancard);
      formdata.append('AadharcardFiles', AadharcardFiles);
      formdata.append('cancelCheck', CancelCheck);
      formdata.append('Vaccination', Vaccination);

      httpCreateCondidatePersonalDetails(formdata, CandidateData?.condidateID).then((res) => {
        if (res.status) {
          setTab(2);
         // setFormValues('')
         // setNumeric('')
          return alert(res.msg);
        } else {
         // setFormValues('')
        //  setNumeric('')
          return alert(res.msg);
        }
      });
    }

    // return alert("All fields are required");
  }
  const saveFamilyDetails = () => {
    //e.preventDefault();
    setTab(3);
  } 
  return (
    <>
      {loading ? (<Loader />) : (<>
        {onecondidate?.status === 1 ? navigate('/joining-success') :

          <>
            {isCheckTwoFectorAuth === 0 ?
              <>
                <EmailVerification emailCheck={emailCheck} setIsCheckTwoFectorAuthtication={setIsCheckTwoFectorAuthtication} />
              </> :
              <>
                <main className="user_maincontainer">
                  <div className="container-fluid">
                    <div className="company_logo">
                      <img src={logo} alt="logo" className="company_logo" />
                    </div>
                    <div className="row">
                      <div className="col-md-1" />
                      <div className="col-md-10">
                        <div className="profile_wrapper mb30">
                          <div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">
                            <a className={`nav-link ${tab === 1 ? 'active' : ''}`} onClick={() => setTab(1)} id="employmentprofile-tab" data-bs-toggle="tab" href="#employmentprofile" data-bs-target="#employmentprofile">
                              Personal Profile
                            </a>
                            <span className="middleline" />
                            <a className={`nav-link ${tab === 2 ? 'active' : ''}`} onClick={() => setTab(2)} id="familydetail-tab" data-bs-toggle="tab" href="#familydetail" data-bs-target="#familydetail">
                              Family Detail
                            </a>
                            <span className="middleline" />
                            <a className={`nav-link ${tab === 3 ? 'active' : ''}`} onClick={() => setTab(3)} id="qualification-tab" data-bs-toggle="tab" href="#qualificationdetail" data-bs-target="#qualificationdetail">
                              Qualification Detail
                            </a>
                            <span className="middleline" />
                            <a className={`nav-link ${tab === 4 ? 'active' : ''}`} onClick={() => setTab(4)} id="previousemployment-tab" data-bs-toggle="tab" href="#previousemploymentdetail" data-bs-target="#previousemploymentdetail">
                              Previous Employment Detail
                            </a>
                          </div>
                          <div className="tab-content" id="profile-tabContent">

                            <div className={`tab-pane fade ${tab === 1 ? 'show active' : ''}`} id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
                              <form onSubmit={handleSavePersonalProfile}>
                                <div className="tab_content">
                                  <div className="dash_white_box_ttl">PERSONAL PROFILE</div>
                                  <div className="row mb25">
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Salutation <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.salutation === 'red' ? 'redvalidation_input' : ''} ${color.salutation === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <select className="form-select" name="salutation" value={salutation} onChange={(e)=>Setsalutation(e.target.value)} id="salutation">
                                            <option value="">Select Salutation</option>
                                            <option value='1'>Mr.</option>
                                            <option value='2'>Mis.</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">First Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span><sup className="error_mgs">*</sup></span></span></div>
                                        <div className="form-input">
                                          <input type="text" name="firstname" value={CandidateData?.first_name} id="firstname" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Middle Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span /></span></div>
                                        <div className="form-input">
                                          <input type="text" name="middlename" value={middlename == ''?middlename:''} onChange={(e)=>Setmiddlename(e.target.value)} id="middlename" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Last Name <span style={{ fontSize: '11px', color: '#848484', fontWeight: 'normal' }}>(As Per Aadhaar Card)<span /></span></div>
                                        <div className="form-input">
                                          <input type="text" name="lastname" value={lastname == ''?lastname:''} onChange={(e)=>Setlastname(e.target.value)} id="lastname" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Father/Husband Name <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.fatherhusbandname === 'red' ? 'redvalidation_input' : ''} ${color.fatherhusbandname === 'green' ? 'greenvalidation_input' : ''}`} >
                                          <input type="text" onChange={(e)=>Setfatherhusbandname(e.target.value)} name="fatherhusbandname" value={fatherhusbandname} id="fatherhusbandname" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Gender <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.gender === 'red' ? 'redvalidation_input' : ''} ${color.gender === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <select className={`form-select`} onChange={(e)=>Setgender(e.target.value)} name="gender" value={gender} id="gender">
                                            <option value=''>Select Gender</option>
                                            <option value='1'>Male</option>
                                            <option value='2'>Female</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">E-Mail <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.email === 'red' ? 'redvalidation_input' : ''} ${color.email === 'green' ? 'greenvalidation_input' : ''}`} >
                                          <input type="text" className={`form-control`} name="email" onChange={(e)=>Setemail(e.target.value)} value={CandidateData?.personal_email} id="email" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Alternate E-Mail</div>
                                        <div className="form-input">
                                          <input type="text" className="form-control" name="alternateemail" onChange={(e)=>Setalternateemail(e.target.value)} value={alternateemail} id="alternateemail" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Phone Number <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.phonenumber === 'red' ? 'redvalidation_input' : ''} ${color.phonenumber === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" className="form-control" name="phonenumber" onChange={(e)=>Setphonenumber(e.target.value)} value={CandidateData ? CandidateData.contact_no : phonenumber} id="phonenumber" placeholder />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Date Of Birth <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.dateofbirth === 'red' ? 'redvalidation_input' : ''} ${color.dateofbirth === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="date" className="form-control" name="dateofbirth" onChange={handledateofjoining} value={moment(dateofbirth).format('yyyy-MM-DD')} id="dateofbirth" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Age</div>
                                        <div className="form-input">
                                          <input type="text" className="form-control" disabled name="age" onChange={(e)=>setAge(e.target.value)} value={age} id="age" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Hobbies</div>
                                        <div className="form-input">
                                          <input type="text" className="form-control" name="hobbies" onChange={(e)=>Sethobbies(e.target.value)} value={hobbies} id="hobbies" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Marital Status <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.Marital_status === 'red' ? 'redvalidation_input' : ''} ${color.Marital_status === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <select className="form-select" name="marital_status" onChange={(e)=>Setmarital_status(e.target.value)} value={marital_status} id="marital_status">
                                            <option value="">--Marital Status--</option>
                                            <option value="1">Married</option>
                                            <option value="2">Unmarried</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Wedding Anniversary Date</div>
                                        <div className="form-input">
                                          <input type="date" name="weddinganniversary" onChange={(e)=>Setweddinganniversary(e.target.value)} value={weddinganniversary} id="weddinganniversary" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Date of joining</div>
                                        <div className="form-input">
                                          <input type="date" name="dateofjoining" onChange={(e)=>Setdateofjoining(e.target.value)} value={moment(CandidateData?.joining_date).format('yyyy-MM-DD')} id="dateofjoining" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Blood Group <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.bloodgroup === 'red' ? 'redvalidation_input' : ''} ${color.bloodgroup === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" id="bloodgroup" name="bloodgroup" onChange={(e)=>Setbloodgroup(e.target.value)} value={bloodgroup} className="form-control" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Weight <sup>( Kg )</sup> </div>
                                        <div className="form-input">
                                          <input type="text" id="Weight" name="Weight" onChange={(e)=>SetWeight(e.target.value)} value={Weight} className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Height <sup>( inches )</sup></div>
                                        <div className="form-input">
                                          <input type="text" id="Height" onChange={(e)=>SetHeight(e.target.value)} value={Height} name="Height" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Emergency Contact Person <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.emergencycontactperson === 'red' ? 'redvalidation_input' : ''} ${color.emergencycontactperson === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setemergencycontactperson(e.target.value)} id="emergencycontactperson" value={emergencycontactperson} name="emergencycontactperson" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Emergency Contact person Relationship <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.personrelation === 'red' ? 'redvalidation_input' : ''} ${color.personrelation === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setpersonrelation(e.target.value)} id="personrelation" name="personrelation" value={personrelation} className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Emergency Phone Number <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.emergencyphonenumber === 'red' ? 'redvalidation_input' : ''} ${color.emergencyphonenumber === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setemergencyphonenumber(e.target.value)} id="emergencyphonenumber" name="emergencyphonenumber" value={emergencyphonenumber} className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Nationality <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.nationality === 'red' ? 'redvalidation_input' : ''} ${color.nationality === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setnationality(e.target.value)} name="nationality" value={nationality} id="nationality" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Aadhaar Card Number <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.aadhaarcardnumber === 'red' ? 'redvalidation_input' : ''} ${color.aadhaarcardnumber === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setaadhaarcardnumber(e.target.value)} name="aadhaarcardnumber" value={aadhaarcardnumber} id="aadhaarcardnumber" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Upload Aadhar Card <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input input-group  ${color.aadharcardfile === 'red' ? 'redvalidation_input' : ''} ${color.aadharcardfile === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="file" onChange={handleAadharcardFilesChange} name="aadharcardfile" className="form-control uploadbtn" id="aadharcardfile" />
                                          {AadharcardFiles != '' ? <button className="btn_2 btn-2"><i className="icon icon-cross"></i></button> : ''}

                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Pan Card Number <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.pancardnumber === 'red' ? 'redvalidation_input' : ''} ${color.pancardnumber === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" onChange={(e)=>Setpancardnumber(e.target.value)} name="pancardnumber" value={pancardnumber} id="pancardnumber" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Upload Pan Card <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input input-group ${color.filepancard === 'red' ? 'redvalidation_input' : ''} ${color.filepancard === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="file" onChange={handleFilepancardChange} name="filepancard" className="form-control uploadbtn" id="filepancard" />
                                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">UAN Number</div>
                                        <div className="form-input">
                                          <input type="text" name="uanno" onChange={(e)=>Setuanno(e.target.value)} value={uanno} id="uanno" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Passport Number</div>
                                        <div className="form-input">
                                          <input type="text" name="Passportno" onChange={(e)=>SetPassportno(e.target.value)} id="Passportno" value={Passportno} className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Passport size Photograph <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input input-group ${color.passportSizePhoto === 'red' ? 'redvalidation_input' : ''} ${color.passportSizePhoto === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="file" name="passportSizePhoto" onChange={handlePassportSizePhotoChange} className="form-control uploadbtn" id="passportSizePhoto" />
                                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Fully Vaccination Certificates</div>
                                        <div className="form-input input-group">
                                          <input type="file" name="Vaccination" onChange={handleVaccinationChange} className="form-control uploadbtn" id="Vaccination" />
                                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Upload Address Proof <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input input-group ${color.AddressProof === 'red' ? 'redvalidation_input' : ''} ${color.AddressProof === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="file" name="AddressProof" onChange={handleAddressProofChange} className="form-control uploadbtn" id="AddressProof" />
                                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab_sub_ttl mb00">Address</div>
                                  <div className="row mb25">
                                    <div className="col-md-6">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Current Address <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.currentAddress === 'red' ? 'redvalidation_input' : ''} ${color.currentAddress === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <textarea className="form-control" onChange={(e)=>SetcurrentAddress(e.target.value)} name="currentAddress" id="currentAddress" value={currentAddress} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Permanent Address <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.PermanentAddress === 'red' ? 'redvalidation_input' : ''} ${color.PermanentAddress === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <textarea className="form-control form-control1" onChange={(e)=>SetPermanentAddress(e.target.value)} name="PermanentAddress" id="PermanentAddress" value={PermanentAddress} />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab_sub_ttl">Bank Details</div>
                                  <div className="row mb25">
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Salary Bank <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.bankSalaryType === 'red' ? 'redvalidation_input' : ''} ${color.bankSalaryType === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <select className="form-select" name="bankSalaryType" onChange={(e)=>SetbankSalaryType(e.target.value)} id="bankSalaryType">
                                            <option value="">Select Salary Type</option>
                                            <option value="1">Salary Account</option>
                                            <option value="2">Saving Account</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Salary Account Number <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.accountno === 'red' ? 'redvalidation_input' : ''} ${color.accountno === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" name="accountno" id="accountno" onChange={(e)=>Setaccountno(e.target.value)} placeholder="Enter Salary Account Number" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk mb10">
                                        <div className="form-label">Salary IFSC Code <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input ${color.ifsc_code === 'red' ? 'redvalidation_input' : ''} ${color.ifsc_code === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="text" name="ifsc_code" id="ifsc_code" onChange={(e)=>Setifsc_code(e.target.value)} placeholder="Enter Salary IFSC Code" className="form-control form-control1" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-blk">
                                        <div className="form-label">Upload Cancel Check <sup className="error_mgs">*</sup></div>
                                        <div className={`form-input input-group ${color.cancelCheck === 'red' ? 'redvalidation_input' : ''} ${color.cancelCheck === 'green' ? 'greenvalidation_input' : ''}`}>
                                          <input type="file" name="cancelCheck" onChange={handleCancelCheckChange} className="form-control uploadbtn" id="cancelCheck" />
                                          {/* <input type="submit" className="btn_7" defaultValue="Upload" name="upload" /> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="tab_footer text-end">
                                  <button className="btn_5" type="submit">Save & Next</button>
                                </div>
                              </form>
                            </div>
                            <AddFamilyDetail emailCheck={emailCheck} userID={CandidateData?.condidateID} saveFamilyDetails={saveFamilyDetails} tab={tab} setTab={setTab} />

                          </div>
                        </div>
                      </div>
                      <div className="col-md-1" />
                    </div>
                  </div>
                  <div className="dash_footer">
                    @2023 Hive. All rights reserved.
                  </div>
                </main>



              </>}
          </>
        }
      </>)}



    </>
  )
}
export default NewJoiningFrom;